<template>
    <div class="auth container-fluid" @keydown.enter.prevent="login">
        <div class="row justify-content-center">
            <div class="col-xl-7 col-lg-8 col-md-10 col-sm-12">
                <div class="locale_block login_page">
                    <locale-button class="locale_block__button--first" language="nl"/>
                    <locale-button class="locale_block__button" language="fr"/>
                </div>
                <div class="block--auth has-no-top-margin">
                    <img class="logo" src="/static/img/logo_minimax.png" alt="Minimax Client Dashboard" title="Minimax Client Dashboard" height="32px">
                    <p>{{ $t('auth.header_sub_signin') }}</p>
                    <form class="form" @submit.prevent="login">
                        <h1>{{ $t('auth.header_signin') }}</h1>
                        <div v-if="loginFailed">
                            <div class="row">
                                <i class="form__input__error-icon mdi mdi-close-circle"></i>
                                <div class="form__error-message--large">
                                    {{$t('auth.invalid_email_password')}}
                                </div>
                            </div>
                        </div>
                        <div class="form__group">
                            <div>
                            <i class="form__input__icon mdi mdi-email-outline" :class="{'has-error':!emailValidInput || emailMissingInput}"></i>
                            <input class="form__input--text underline has-icon"
                                   @keydown.space.prevent
                                   @keydown = "emailMissingInput=false; emailValidInput=true; loginFailed=false"
                                   name='email'
                                   autocomplete="email"
                                   v-model="email"
                                   :placeholder="$t('auth.hint_email')"
                                   :class="{'has-error': !emailValidInput || emailMissingInput}"
                            />
                            </div>
                            <div v-if="emailMissingInput">
                                <div class="row">
                                        <i class="form__input__error-icon mdi mdi-close-circle"></i>
                                    <div class="form__error-message">
                                        {{$t('auth.error_missing_email')}}
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="!emailValidInput">
                                <div class="row">
                                        <i class="form__input__error-icon mdi mdi-close-circle"></i>
                                    <div class="form__error-message">
                                        {{$t('auth.error_email')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form__group">
                            <div>
                            <i class="form__input__icon mdi mdi-account-key" :class="{'has-error': passwordMissingInput}"></i>
                            <input class="form__input--text underline has-icon"
                                   type="password"
                                   @keydown = "passwordMissingInput=false; loginFailed=false"
                                   autocomplete="password"
                                   name="password"
                                   v-model="password"
                                   :placeholder="$t('auth.hint_password')"
                                   :class="{'has-error': passwordMissingInput}"
                            />
                            </div>
                             <div v-if="passwordMissingInput">
                            <div class="row">
                                    <i class="form__input__error-icon mdi mdi-close-circle"></i>
                                <div class="form__error-message">
                                    {{$t('auth.error_password')}}
                                </div>
                            </div>
                        </div>
                        </div>

                        <div class="form__buttons">
                            <div class="row">
                                <div class="col-12 col-md-6 order-md-first">
                                    <router-link tag="button" class="button full-width is-forgot-password" :to="{ name: 'reset'}">
                                        {{$t('auth.link_forgot_password')}}
                                    </router-link>
                                    </div>
                                <div class="col-12 col-md-6 order-first">
                                    <button type="submit"
                                            class="button--cta full-width"
                                            :disabled="busy"
                                            :class="{'is-loading': busy}">
                                        {{$t('auth.button_signin')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Component, Watch} from 'vue-property-decorator';
    import {LOGIN} from '../../../store/modules/auth';
    import LocaleButton from '../../general/LocaleButton';

    @Component({
        components: {LocaleButton}
    })
    export default class LoginForm extends Vue {
        name = 'login-form';

        busy = false;
        error = '';

        email = '';
        password = '';
        emailValidInput = true
        passwordMissingInput = false
        emailMissingInput = false
        loginFailed = false


        /**
         * Validate email and password and sign a user in.
         */
        async login() {
            this.emailMissingInput = (this.email.trim().length == 0);
            this.passwordMissingInput = (this.password.trim().length == 0);
            this.emailValidInput = /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(this.email);  //eslint-disable-line

            if (!this.emailMissingInput && this.emailValidInput && !this.passwordMissingInput) {
                this.error = false;
                this.busy = true;
                const payload = {email: this.email, password: this.password};

                try {
                    await this.$store.dispatch(LOGIN, payload);
                } catch (e){
                    if (e.response && e.response.data && e.response.data.data) {
                        const data = e.response.data.data;
                        this.error = data.errors[0].message;
                    } else {
                        this.loginFailed = true;
                        this.error = this.$t('auth.notify_login_failure');
                    }
                    this.$notify.error(this.error);
                } finally {
                    this.busy = false;
                    const redirect = this.$route.query.redirect;
                    if (redirect) {
                        this.$router.replace(redirect);
                    } else {
                        this.$router.replace({
                            name: 'home'
                        });
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/LoginForm.vue